import React from "react";

type CardErrorSvgPropsType = {
  text?: string;
}

const CardErrorSvg: React.FC<CardErrorSvgPropsType> = ({ text }) => {

  const cardErrorSvg = <div className="aspect-[5/3] border-2 border-gray-300 border-dashed flex items-center justify-center bg-gray-100 text-gray-400 text-2xl">{text}</div>
    
  return (cardErrorSvg);
}

export default CardErrorSvg;